import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import './extra.css';
import { initAuth } from './auth';
import App from './App';
import { ToastProvider } from './ui';

const root = createRoot(document.getElementById('root')!);
root.render(<div className="boot"><img src="/conves-logo-sobre-azul.png" alt="" width="176" height="110" /><p>Abrindo o Convés…</p></div>);

initAuth()
  .then(launch => root.render(<StrictMode><ToastProvider><App launch={launch} /></ToastProvider></StrictMode>))
  .catch(() => root.render(<div className="boot"><p>Não foi possível entrar com a conta do colégio. Recarregue a página; se continuar, avise a TI.</p></div>));
